import React, { Component } from "react";
import { connect } from "react-redux";
import NewBusinessReport from "./NewBusinessReport";

import { Layout, Breadcrumb } from "antd";
const { Content } = Layout;

class Dashboard extends Component {
  render() {
    return (
      <>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>New Business report</Breadcrumb.Item>
        </Breadcrumb>
        <div className="site-layout-background main-frame">
          <NewBusinessReport />
        </div>
      </>
    );
  }
}

export default connect()(Dashboard);
